/**
 * Quelles notes de version la page et la pastille affichent : les VRAIES, en
 * développement comme en production.
 *
 * ⚠️ POURQUOI CE SÉLECTEUR RESTE, ALORS QU'IL NE CHOISIT PLUS RIEN. Cette page
 * affichait naguère un faux commit `8f3c2a1` et un faux `Build #452`, en dur
 * DANS la boucle de rendu — de la donnée fictive présentée à des clients dans
 * un écran qui a l'air officiel. Un historique SIMULÉ a ensuite servi, derrière
 * `import.meta.env.DEV`, à régler le style des notes avant la première note
 * réelle ; il a été retiré avec la 1.1.0 (22/10/2026), pour que le poste du PO
 * montre exactement ce que voient les clients.
 *
 * La page et la pastille passent toujours par ce module, et le test
 * `changelog/__tests__/la-simulation-natteint-jamais-la-production` vérifie
 * qu'il sert `releases` et rien d'autre : une simulation qui reviendrait, même
 * derrière une barrière DEV, le ferait tomber (vitest tourne en DEV).
 */

import { releases } from './releases'
import type { Release } from './releases'

export const releasesAffichees: Release[] = releases
